import _ from 'lodash';
import createCachedSelector from 're-reselect';
import { getPredictor } from '../getPredictor';

export const getFunctionDescriptions = createCachedSelector(
  [getPredictor],
  predictor => _.chain(predictor).get('functionMappings').map(({ sensor, function: f }) => [sensor, f]).fromPairs().value()
)(
  (state, chartType) => chartType
);